import { Routes, Route } from 'react-router-dom';

import { HomePage } from 'pages';

import { useTranslations } from './context/translations';

const App = () => {
  const { isLoading } = useTranslations();
  if (isLoading) return null;

  return (
    <Routes>
      <Route path="/:lang?/" element={<HomePage />} />
    </Routes>
  );
};

export default App;
